import { CreateEntranceRequestBuilder } from "client-sdk/src/entrances/entrances";
import { Entrance } from "client-sdk/src/entrances/interface";
import handleError from "../../../utils/handleError";
import Client from "client-sdk/src/client";
// export default const getDrivers = () => {

// }

const token = localStorage.getItem("token");

export async function createEntrance(entranceData: Entrance) {
  try {
    const createVehicleEntrance = new CreateEntranceRequestBuilder().data(
      entranceData,
    ).build();
    const client = new Client(token as string);
    const response = client.execute(
      createVehicleEntrance,
    );
    return response;
  } catch (error) {
    handleError(error.response);
  }
}

export default createEntrance;
